import * as _ from 'underscore'

import { Enums } from '../../models/common'

import { ColumnModel } from '../../modules/api/api.models'

import { OrderService, ORDER_SERVICE_NAME } from '../order'
import { UserSessionService, USER_SESSION_SERVICE_NAME } from '../user-session'


//#region Public Types

export const PACKAGE_RELATED_ORDERS_SERVICE_NAME = 'PackageRelatedOrdersService'
export const PACKAGE_RELATED_ORDERS_SERVICE_PROVIDER_NAME = 'PackageRelatedOrdersServiceProvider'

//#endregion


export class PackageRelatedOrdersService {

    //#region Consts

    public static get LOG_PREFIX(): string { return '[SIMAX.Services.Package.RelatedOrders]' }


    //#endregion


    //#region Ctor

    constructor(private orderService: OrderService) { }

    //#endregion


    //#region Columns

    public getRelatedOrdersColumns(): JQueryPromise<ColumnModel[]> {
        return this.orderService.getMainGridColumns()
    }

    //#endregion
}


export class PackageRelatedOrdersServiceProvider implements ng.IServiceProvider {

    //#region IServiceProvider Implementation 

    public $get = [ORDER_SERVICE_NAME, function (orderService: OrderService) {
        return new PackageRelatedOrdersService(orderService);
    }]

    //#endregion
} 